import React from 'react';
import Column from '@amzn/meridian/column';
import Text from '@amzn/meridian/text';
import Tag from '@amzn/meridian/tag';
import Box from '@amzn/meridian/box';

/**
 * Supplier Gateway · Promised Date. The feature is still under development, so
 * this shows an "under development" placeholder.
 */
export default function PromisedDateScreen() {
    return (
        <Box minHeight={360}>
            <Column
                alignmentHorizontal="center"
                alignmentVertical="center"
                spacing="300"
                spacingInset="500"
                height="100%"
                width="100%"
            >
                <Column alignmentHorizontal="center" spacing="300" maxWidth={460}>
                    <Text type="d100">🚧</Text>
                    <Tag type="warning">Under development</Tag>
                    <Text type="h400" alignment="center">
                        Promised Date
                    </Text>
                    <Text color="secondary" alignment="center">
                        This feature is still being developed and isn&rsquo;t available yet. For
                        access or timelines, please check with your administrator.
                    </Text>
                </Column>
            </Column>
        </Box>
    );
}
